import React from "react";

import {
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { CheckIcon } from "../../../../icons_v2/general";
import { DateOption } from "./types";

type DateRangeOptionProps = {
  quickSelection: DateOption;
  quickSelectionOption: DateOption;
  label: string;
  onPress: () => void;
};

export const DateRangeOption = ({
  quickSelection,
  quickSelectionOption,
  label,
  onPress,
}: DateRangeOptionProps) => {
  const isSelected = quickSelection === quickSelectionOption;
  return (
    <Pressable
      accessibilityHint={quickSelectionOption}
      borderRadius={"2"}
      paddingVertical={4}
      paddingHorizontal={4}
      backgroundColor={isSelected ? "surface-secondary" : "surface-primary"}
      _hover={{ backgroundColor: "surface-secondary" }}
      onPress={onPress}
    >
      <HStack justifyContent={"space-between"}>
        <Text variant={"mainBaseSemiBold"} lineHeight={16}>
          {label}
        </Text>
        {isSelected ? <CheckIcon /> : null}
      </HStack>
    </Pressable>
  );
};
